export default __webpack_public_path__ + "static/mapviewer-f5edbf9a3e7fbc4335f594dcebf10fcc.png";